import { useTheme } from "@emotion/react";
import { Button, IconButton, Stack } from "@mui/material";
import MainMenu from "components/menus/MainMenu";
import ChargeAccountDisplay from "components/react-lib/stripe-credit-payments/ChargeAccountDisplay";
import { useAuth } from "context/react-lib/firebase-auth/AuthProvider";
import { fonts } from "fonts";
import React, { useState, useEffect } from "react";

export default function View({
  children,
  renderLeftActions = () => null,
  renderRightActions = () => null,
}) {
  const theme = useTheme();

  const auth = useAuth();
  const uid = auth.currentUser?.uid;

  const [viewportHeight, setViewportHeight] = useState(window.innerHeight);

  useEffect(() => {
    function updateHeight() {
      if(window.visualViewport) {
        setViewportHeight(window.visualViewport.height);
      }
    }
    window.addEventListener("resize", updateHeight);
    updateHeight();
    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, []);

  return (
    <Stack
      sx={{
        width: "100vw",
        height: `${viewportHeight}px`,
        backgroundColor: theme.background,
        zIndex: 0,
        position: "relative",
        overflowX: "hidden",
        overflowY: "hidden",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        px={1}
        sx={{
          height: "64px",
          position: "sticky",
          top: 0,
          zIndex: 1,
          backgroundColor: theme.background,
        }}
      >
        <Stack
          direction="row"
          spacing={1}
          alignItems="center"
          justifyContent="center"
        >
          {uid && <MainMenu />}
          {renderLeftActions()}
        </Stack>
        <Stack
          direction="row"
          spacing={0}
          alignItems="center"
          justifyContent="center"
        >
          {uid && (
            <ChargeAccountDisplay
              negativeCreditsColor={theme.palette.secondary.main}
              uid={uid}
              nameProps={{
                color: theme.palette.text.main,
                variant: "caption",
                fontFamily: fonts.geist,
              }}
              amountProps={{
                color: theme.palette.text.main,
                fontWeight: "bold",
                fontFamily: fonts.anton,
              }}
              containerProps={{
                p: 2,
              }}
            />
          )}
          {renderRightActions()}
        </Stack>
      </Stack>
      <Stack
        sx={{
          height: `${viewportHeight - 64}px`,
          width: "100%",
          zIndex: 0,
          overflowY: "hidden",
        }}
        direction="row"
      >
        {children}
      </Stack>
    </Stack>
  );
}
